/**
 * ★★ WE — A ORDEM DE PROGRESSO DAS ETAPAS. Puro: nenhum Firestore, nenhum React.
 *
 * ★★ POR QUE ESTA CONSTANTE EXISTE, SE `ETAPAS_KANBAN` JÁ É UMA LISTA ORDENADA.
 *
 * Porque as duas listas **coincidem por acidente**, e só uma delas é uma decisão.
 * `ETAPAS_KANBAN` (`@/lib/constants`) é a **ordem de DESENHO das colunas** do quadro — medido na WE: ela é
 * usada em exatamente dois lugares, `FunilPage.jsx` e `LeadsPage.jsx`, os dois para renderizar. Ninguém
 * nunca a declarou como ordem de PROGRESSO, e antes desta peça **não existia comparação de ordem entre
 * etapas em lugar nenhum do código** (`docs/we-medicao.md` §3).
 *
 * Se esta regra lesse o kanban, bastaria alguém arrastar uma coluna de lugar — uma mudança visual, que
 * ninguém associaria a regra de negócio — para o sistema passar a aceitar, ou a recusar, gravações
 * diferentes. A ordem de desenho pode mudar por gosto; esta aqui só muda por decisão.
 *
 * ★ Há guarda de fonte (`web/src/leads/we.guardas.test.js`) que falha se este arquivo importar
 * `@/lib/constants`, e a mutação que troca esta lista pelo kanban (E7) morre nela.
 */

/**
 * As sete etapas, na ordem em que o lead PROGRIDE.
 *
 * As duas colunas de "não" ocupam posição própria de propósito: `nao_compareceu` vem depois de `agendado`
 * (faltar é um desfecho da consulta marcada, não um retrocesso), e `nao_fechou` vem depois de `compareceu`
 * (quem não fechou compareceu antes). É o que faz `agendado → nao_compareceu` ser avanço e
 * `nao_fechou → compareceu` ser recuo — os dois casos reais medidos na WE.
 */
export const ORDEM_DE_PROGRESSO = [
  'novo',
  'nao_agendou',
  'agendado',
  'nao_compareceu',
  'compareceu',
  'nao_fechou',
  'fechado',
];

/** Posição na ordem de progresso; -1 para etapa desconhecida (legada, vazia, inventada). */
export const posicao = (etapa) => ORDEM_DE_PROGRESSO.indexOf(etapa);

/**
 * `para` vem DEPOIS de `de` na ordem de progresso?
 *
 * ★ Etapa desconhecida (`-1`) responde **false**: na dúvida, não mexe. Um lead numa etapa legada
 * (`em_negociacao`, `perdido`) não é empurrado por uma baixa de consulta — quem decide o destino dele é uma
 * pessoa, pela tela.
 */
export function ehAvanco(de, para) {
  const i = posicao(de);
  const j = posicao(para);
  if (i < 0 || j < 0) return false;
  return j > i;
}
